export default "__VITE_ASSET__CDJvC0XM__"